module.exports = __webpack_public_path__ + "assets/img/list.c8494853.png";